import React from 'react';
import { DollarSign, AlertCircle } from 'lucide-react';

/**
 * Компонент для ввода дополнительных комиссий и сборов
 */
const AdditionalFeesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  // Если комиссии отключены, возвращаем только чекбокс
  if (!formData.includeFees) {
    return (
      <div className="mb-6">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeFees"
            checked={formData.includeFees}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Учитывать дополнительные комиссии и сборы
          </span>
        </label>
      </div>
    );
  }

  // Если комиссии включены, отображаем полную форму
  return (
    <div className="mb-6">
      <label className="inline-flex items-center mb-4">
        <input
          type="checkbox"
          name="includeFees"
          checked={formData.includeFees}
          onChange={handleInputChange}
          className="form-checkbox"
        />
        <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
          Учитывать дополнительные комиссии и сборы
        </span>
      </label>

      <div className="bg-yellow-50 dark:bg-yellow-900/20 p-4 rounded-lg border border-yellow-200 dark:border-yellow-800">
        <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <DollarSign className="w-5 h-5 mr-2 text-yellow-500" />
          Комиссии и сборы по кредиту
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Начальная комиссия */}
          <div>
            <label htmlFor="initialFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Начальная комиссия
            </label>
            <input
              type="text"
              id="initialFee"
              name="initialFee"
              value={formData.initialFee}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.initialFee ? 'input-error' : ''}`}
              placeholder="Сумма комиссии при оформлении"
            />
            {errors.initialFee && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.initialFee}
              </p>
            )}
          </div>

          {/* Ежемесячная комиссия */}
          <div>
            <label htmlFor="monthlyFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Ежемесячная комиссия
            </label>
            <div className="flex">
              <input
                type="text"
                id="monthlyFee"
                name="monthlyFee"
                value={formData.monthlyFee}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.monthlyFee ? 'input-error' : ''}`}
                placeholder="Сумма ежемесячного сбора"
              />
              <select
                name="monthlyFeeType"
                value={formData.monthlyFeeType}
                onChange={handleInputChange}
                className="form-select ml-2 w-1/3"
              >
                <option value="fixed">Фиксированная</option>
                <option value="percent">% от остатка</option>
              </select>
            </div>
            {errors.monthlyFee && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.monthlyFee}
              </p>
            )}
          </div>

          {/* Комиссия за досрочное погашение */}
          <div>
            <label htmlFor="earlyRepaymentFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Комиссия за досрочное погашение
            </label>
            <div className="flex">
              <input
                type="text"
                id="earlyRepaymentFee"
                name="earlyRepaymentFee"
                value={formData.earlyRepaymentFee}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.earlyRepaymentFee ? 'input-error' : ''}`}
                placeholder="Комиссия за досрочное погашение"
              />
              <select
                name="earlyRepaymentFeeType"
                value={formData.earlyRepaymentFeeType}
                onChange={handleInputChange}
                className="form-select ml-2 w-1/3"
              >
                <option value="fixed">Фиксированная</option>
                <option value="percent">% от суммы</option>
              </select>
            </div>
            {errors.earlyRepaymentFee && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.earlyRepaymentFee}
              </p>
            )}
          </div>
        </div>

        <div className="mt-4 bg-yellow-100 dark:bg-yellow-900/30 p-3 rounded-lg border border-yellow-200 dark:border-yellow-800">
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-yellow-600 dark:text-yellow-400 mr-3 mt-1" />
            <div>
              <h4 className="text-sm font-medium text-yellow-700 dark:text-yellow-300 mb-1">
                Информация о комиссиях в России
              </h4>
              <p className="text-xs text-yellow-600 dark:text-yellow-400">
                Согласно закону №353-ФЗ "О потребительском кредите", банки не имеют права взимать комиссию 
                за досрочное погашение ипотеки. Для потребительских кредитов комиссия за досрочное погашение 
                может взиматься только в первые 30 дней с момента получения кредита. При наличии дополнительных 
                комиссий, рассмотрите возможность рефинансирования кредита на более выгодных условиях.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalFeesSection;